import { LoadingOverlayComponent } from '../../shared/components/loading-overlay/loading-overlay.component';

import { AmpelService } from './ampel.service';
import { LanguageService } from 'src/app/shared/services/language.service';

import { DatexPipe } from '../../shared/datex.pipe';

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  OnInit,
  output,
  signal,
  TemplateRef,
  untracked,
  viewChild,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { TranslateModule } from '@ngx-translate/core';

import {
  FaIconComponent,
  FaLayersComponent,
} from '@fortawesome/angular-fontawesome';
import { IconPrefix } from '@fortawesome/fontawesome-svg-core';

import { TippyDirective } from '@ngneat/helipopper';
import { Moment } from 'moment';
import moment from 'moment';
import { isNil } from 'src/utils/utils';

export const MODULES = [CommonModule, MatCardModule, TranslateModule];
export const COMPONENTS = [FaIconComponent, FaLayersComponent];
export const PIPES = [DatexPipe];
export const DIRECTIVES = [TippyDirective];

@Component({
  selector: 'app-dashboard-ampel',
  templateUrl: './dashboard-ampel.component.html',
  styleUrls: [
    './dashboard-ampel.component.scss',
    '../dashboard.component.scss',
  ],
  providers: [AmpelService],
  imports: [
    ...MODULES,
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    LoadingOverlayComponent,
  ],
})
export class DashboardAmpelComponent implements OnInit {
  private injector = inject(Injector);
  private ampelService = inject(AmpelService);
  public languageService = inject(LanguageService);

  // NOTE: viewChild('topCardsDashboardAmpel') needed to be able to render mat-cards for top cards in dashboard view without
  // component tag which would interfere with css
  topCardsDashboardAmpelTemplate = viewChild<TemplateRef<any>>(
    'topCardsDashboardAmpel'
  );
  isTopCard = input<boolean>();
  refresh = input<number>();
  ampelDtg = output<string>();

  previousRefresh = signal(null);
  ampelData = signal<any>({});
  ampelStatus = ['GREEN', 'YELLOW', 'RED'];
  icons = {
    GREEN: 'fal' as IconPrefix,
    YELLOW: 'fal' as IconPrefix,
    RED: 'fal' as IconPrefix,
  };
  ampelColor = signal('GREEN');
  latestDtg: Moment;
  isLoading = signal(true);

  constructor() {
    this.refreshAmpelData();
  }

  ngOnInit(): void {
    this.getAmpelData();
  }

  getAmpelData(): void {
    this.ampelService.getAmpelInfo(2311).subscribe(
      data => {
        const ampelData = data['trafficlightsObject'];
        const dtg = moment(ampelData['writtenAt']);
        if (!this.latestDtg || this.latestDtg.isBefore(dtg)) {
          this.isLoading.set(true);
          this.latestDtg = dtg;
          this.ampelData.set({ ...ampelData });
          this.setIcons();
          this.ampelDtg.emit(ampelData['writtenAt']);
          this.isLoading.set(false);
        }
      },
      error => console.log('Error DashboardAmpel getAmpelData', error)
    );
  }

  setIcons(): void {
    this.ampelColor.set(
      this.ampelStatus[this.translateAmpelStatus(this.ampelData()['status'])]
    );
    this.icons[this.ampelColor()] = 'fas';
  }

  translateAmpelStatus(value: number): number {
    if (value < 3) {
      return value;
    }
    const statusTranslate = {
      4: 2,
      7: 2,
      12: 2,
      3: 1,
      5: 1,
      11: 1,
      6: 0,
      8: 0,
      10: 0,
    };
    return statusTranslate.hasOwnProperty(value) ? statusTranslate[value] : 0;
  }

  private refreshAmpelData() {
    effect(
      () => {
        const refresh = this.refresh();
        untracked(() => {
          const previousRefresh = this.previousRefresh();
          if (!isNil(previousRefresh) && refresh > previousRefresh) {
            this.getAmpelData();
          }
          this.previousRefresh.set(refresh);
        });
      },
      { injector: this.injector }
    );
  }
}
